export default __webpack_public_path__ + "static/media/settingIcon.bfd86e35.svg";